<template>
  <span class="font-bold text-primary">*</span>
</template>
